
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
    Emit,
    Inject,
    Model,
    Prop,
    Provide,
    Watch,
} from "vue-property-decorator";
import { WebAPI } from "../../../../web-api";

import {
    filterByTag,
    filterByRegex,
    filterByFullPath,
    filterByFilename,
    downloadFile,
} from "../../../../file-tree-util";

import { Store as store } from '../../../../store';

import NglViewer from "./NglViewer.vue";

@Component({
    filters: {},
    components: {
        NglViewer
    },
})
export default class LaxyNglViewer extends Vue {

    //pdbFileId: string = '4aIhItPH2ml0ZPCzW8WkLg';
    //jobId: string = '7iwC7PemKGkd5uxzvMIapu';

    @Prop({ type: String, default: "" })
    public jobId: string;

    @Prop({ type: String, default: "" })
    public fileId: string;

    @Prop({ type: Boolean, default: true })
    public showDownloadButton: boolean;

    get downloadURL() {
        const access_token = store.getters.jobAccessToken(this.jobId);
        return WebAPI.downloadFileByIdUrl(this.fileId, null, access_token)
    }

    doDownload(event: any) {
        window.open(this.downloadURL);
        //this.$emit("click");
    }
}
